import LoginForm from './LoginForm';

export default LoginForm;


// WEBPACK FOOTER //
// ./src/components/forms/LoginForm/index.js